export default "__VITE_ASSET__Be$8njci__"